<div
  class="card-box hint-card editing-requested-user-hint"
  data-cy="editing-requested-user-hint"
  *ngIf="isEditingRequestedUser$ | async">
  {{ "editingRequestedUserHint" | i18n }}
</div>
<form
  #profileForm="ngForm"
  class="profile-edit">
  <ng-container *ngIf="profileUser$ | async; else loadingProfile">
    <div
      class="card-box"
      *ngIf="profileUser && !profileUser.isInSetup">
      <h1
        class="card-title"
        data-cy="profile-contact-title">
        {{ ("contactSettings" | i18n) || "contact settings" | titlecase }}
      </h1>
      <div
        class="card-subtitle"
        *ngIf="profileUser && !(isEditingRequestedUser$ | async)">
        {{ profileUser.firstName }} {{ profileUser.lastName }}
      </div>
      <div class="row">
        <div
          class="col-md-6"
          *ngIf="!(isEditingRequestedUser$ | async)">
          <mat-form-field *ngIf="profileUser">
            <mat-label>{{ ("sex" | i18n) || "sex" | titlecase }}</mat-label>
            <mat-select
              [disabled]="!hasEditPermission"
              [(ngModel)]="profileUser.sex"
              required
              name="sex"
              data-cy="profile-sex-select">
              <mat-option [value]="sexEnum.FEMALE">{{
                ("femaleSex" | i18n) || "female" | titlecase
              }}</mat-option>
              <mat-option [value]="sexEnum.MALE">{{
                ("maleSex" | i18n) || "male" | titlecase
              }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col-md-6">
          <mat-form-field
            *ngIf="
              dispoCustomer &&
              profileUser &&
              loggedInUser?.role !== roleEnum.POOL &&
              dispoCustomer.branches &&
              !isDispoEditingPooler &&
              profileUser.role === roleEnum.DISPO
            ">
            <mat-label>{{
              ("branch" | i18n) || "branch" | titlecase
            }}</mat-label>
            <mat-select
              [disabled]="!hasEditPermission"
              [(ngModel)]="profileUser.branch"
              required
              name="branch">
              <mat-option
                *ngFor="let branch of dispoCustomer.branches"
                [value]="branch.id">
                {{ branch.displayName }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>

      <div
        class="row"
        *ngIf="!(isEditingRequestedUser$ | async)">
        <div class="col-md-6">
          <mat-form-field *ngIf="profileUser">
            <mat-label>
              {{ ("firstName" | i18n) || "first name" | titlecase }}
            </mat-label>
            <input
              [disabled]="!hasEditPermission"
              matInput
              [(ngModel)]="profileUser.firstName"
              name="firstName"
              required
              data-cy="profile-firstName-input" />
          </mat-form-field>
        </div>
        <div class="col-md-6">
          <mat-form-field *ngIf="profileUser">
            <mat-label>
              {{ ("lastName" | i18n) || "last name" | titlecase }}
            </mat-label>
            <input
              [disabled]="!hasEditPermission"
              matInput
              [(ngModel)]="profileUser.lastName"
              name="lastname"
              required
              data-cy="profile-lastName-input" />
          </mat-form-field>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <mat-form-field *ngIf="profileUser">
            <mat-label> {{ ("email" | i18n) || "Email" }} </mat-label>
            <input
              [disabled]="
                !hasEditPermission || !!(isEditingRequestedUser$ | async)
              "
              matInput
              type="email"
              [(ngModel)]="profileUser.email"
              name="email"
              required
              pattern="[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,63}"
              data-cy="profile-email-input" />
          </mat-form-field>
          <div
            class="hint"
            *ngIf="getEmailOptIn"
            data-cy="profile-email-changed-hint">
            {{ ("yourEmailWasSetTo" | i18n) || "Ihre E-Mailadresse wurde auf" }}
            <b> {{ getEmailOptIn.value }} </b>
            {{ ("wasChangedAt" | i18n) || "geändert am " }}
            {{ getEmailOptIn.timestamp * 1000 | date: "short" }}
            <br />

            {{
              ("optInEmailMessage" | i18n) ||
                "Bitte bestätigen Sie die Änderung mit dem Bestätigungslink, welchen wir per E-Mail gesendet haben, damit die neue E-Mailadresse aktiv wird."
            }}
          </div>
        </div>

        <div
          class="col-md-6"
          *ngIf="!(isEditingRequestedUser$ | async)">
          <mat-form-field *ngIf="profileUser">
            <mat-label>
              {{ ("phoneNumber" | i18n) || "phone number" | titlecase }}
            </mat-label>
            <input
              [disabled]="!hasEditPermission"
              [required]="
                !!(
                  profileUser?.twoFactorAuthEnabled ||
                  profileUser?.twoFactorAuthRequired
                )
              "
              matInput
              type="tel"
              placeholder="+41791234567"
              [(ngModel)]="profileUser.phone"
              name="phone"
              (keyup)="trimPhone()"
              autocomplete="tel"
              pattern="\+?[1-9]\d{0,14}"
              data-cy="profile-phone-input" />

            <mat-icon
              *ngIf="getPhoneOptIn && !phoneResetLockSeconds"
              (click)="resendSMS()"
              matSuffix
              [matTooltip]="('resend' | i18n) || 'Erneut schicken'"
              svgIcon="refresh"></mat-icon>
            <ng-container
              *ngIf="phoneResetLockSeconds"
              matSuffix>
              {{ phoneResetLockSeconds }}
            </ng-container>
          </mat-form-field>

          <div
            class="hint"
            *ngIf="getPhoneOptIn"
            data-cy="profile-phone-changed-hint">
            {{ ("yourPhoneWasSetTo" | i18n) || "Ihre Telefonnummer wurde auf" }}
            <b> {{ getPhoneOptIn.value }} </b>
            {{ ("wasChangedAt" | i18n) || "geändert am" }}
            {{ getPhoneOptIn.timestamp * 1000 | date: "short" }}
            <br />
            {{
              ("optInPhoneMessage" | i18n) ||
                "Bitte bestätigen Sie die Änderung mit dem Bestätigungslink, welchen wir per SMS gesendet haben, damit die neue Telefonnummer aktiv wird."
            }}
          </div>
        </div>
      </div>
      <div
        class="row"
        *ngIf="!(isEditingRequestedUser$ | async)">
        <div class="col-md-6">
          <mat-form-field *ngIf="profileUser">
            <mat-label>{{
              ("systemLanguage" | i18n) || "language" | titlecase
            }}</mat-label>
            <mat-select
              [disabled]="!hasEditPermission"
              [(ngModel)]="profileUser.locale"
              data-cy="profile-language-select"
              name="language">
              <mat-option
                *ngFor="let language of languageOptions"
                [value]="language.language">
                {{ language.labelKey | i18n | titlecase }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
      <div
        class="row"
        *ngIf="
          (loggedInUser?.role === roleEnum.DISPO && !isDispoEditingPooler) ||
          editedUserRole === roleEnum.DISPO
        ">
        <div class="col">
          <mat-form-field
            [hintLabel]="
              ('ccEmailHint' | i18n) ||
              'Bitte geben Sie die E-Mailadressen Komma separiert ein.'
            ">
            <mat-label>
              {{ ("ccEmails" | i18n) || "CC Emails" }}
            </mat-label>
            <input
              [disabled]="!hasEditPermission && !partialOwnEditPermissions"
              matInput
              type="text"
              [(ngModel)]="ccEmails"
              pattern="([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,63}[,]*((?<=,)\s)*)+"
              name="ccEmails"
              data-cy="profile-ccEmails-input" />
          </mat-form-field>
        </div>
      </div>
      <app-accordion
        *ngIf="
          (isDispoEditingPooler || loggedInUser?.role === roleEnum.POOL) &&
          editedUserRole === roleEnum.POOL
        "
        class="additional-information-accordion"
        [collapsed]="additionalInformationCollapsed">
        <app-accordion-header
          [collapseOnHeaderClick]="true"
          (click)="
            additionalInformationCollapsed = !additionalInformationCollapsed
          "
          class="additional-information-accordion-header"
          data-cy="profile-additional-information-panel-header">
          <div class="accordion-title">
            {{ ("additionalInformation" | i18n) || "Zusatzinformationen" }}
          </div>
        </app-accordion-header>
        <app-accordion-content class="additional-information-accordion-content">
          <div
            *ngIf="profileUser"
            class="additional-information-accordion-content-inner">
            <div
              class="row mb-4"
              *ngIf="
                customerInformation &&
                dispoCustomer?.enableEmployments &&
                dispoCustomer?.enableJobs &&
                dispoCustomer?.customerType === CustomerTypeEnum.AGENCY
              ">
              <div class="col-sm-6">
                <mat-checkbox
                  data-cy="profile-enable-jobs-checkbox"
                  [(ngModel)]="customerInformation.enableJobs"
                  [disabled]="
                    loggedInUser?.role === roleEnum.POOL || !hasEditPermission
                  "
                  name="enableJobs">
                  {{ ("enableJobs" | i18n) || "Springer Pool aktivieren" }}
                </mat-checkbox>
              </div>
              <div class="col-sm-6">
                <mat-checkbox
                  data-cy="profile-enable-employments-checkbox"
                  [(ngModel)]="customerInformation.enableEmployments"
                  [disabled]="
                    loggedInUser?.role === roleEnum.POOL || !hasEditPermission
                  "
                  name="enableEmployments">
                  {{
                    ("enableEmployments" | i18n) || "Temporär Pool aktivieren"
                  }}
                </mat-checkbox>
              </div>
            </div>
            <div
              class="row"
              *ngIf="
                customerInformation &&
                dispoCustomer?.enablePoolerTypes &&
                dispoCustomer?.poolerTypes?.length
              ">
              <div class="col-sm-6">
                <app-pooler-type-select
                  [ngModel]="
                    customerInformation.poolerType
                      ? customerInformation.poolerType.id
                      : undefined
                  "
                  (ngModelChange)="poolerTypeChanged($event)"
                  name="pooler-type"
                  data-cy="profile-pooler-type-select"
                  [disabled]="
                    loggedInUser?.role === roleEnum.POOL || !hasEditPermission
                  ">
                </app-pooler-type-select>
              </div>
            </div>
            <div class="row">
              <div
                *ngIf="!(isEditingRequestedUser$ | async)"
                [class.col-sm-6]="isDispoEditingPooler"
                [class.col-12]="!isDispoEditingPooler">
                <app-mobility-select
                  *ngIf="
                    !dispoCustomer?.hiddenFields?.profileMobility &&
                    profileUser.role === roleEnum.POOL
                  "
                  data-cy="profile-mobility-select"
                  [(ngModel)]="profileUser.car"
                  name="car"
                  [disabled]="
                    loggedInUser?.role === roleEnum.POOL || !hasEditPermission
                  ">
                </app-mobility-select>
              </div>
              <div
                class="col-sm-6"
                *ngIf="
                  isDispoEditingPooler &&
                  !dispoCustomer?.hiddenFields?.profileInternalId
                ">
                <mat-form-field *ngIf="customerInformation">
                  <mat-label>
                    {{ ("internalId" | i18n) || "Interne ID" }}
                  </mat-label>
                  <input
                    [disabled]="!hasEditPermission"
                    matInput
                    [name]="customerInformation.customerName + 'internalId'"
                    [(ngModel)]="customerInformation.internalId" />
                </mat-form-field>
                <mat-form-field *ngIf="!customerInformation">
                  <mat-label>
                    {{ ("internalId" | i18n) || "Interne ID" }}
                  </mat-label>
                  <input
                    [disabled]="!hasEditPermission"
                    matInput
                    name="internalId"
                    [(ngModel)]="newInternalId" />
                </mat-form-field>
              </div>
              <div
                class="col-sm-6"
                *ngIf="isDispoEditingPooler && dispoCustomer?.enablePerigonApi">
                <mat-form-field *ngIf="customerInformation">
                  <mat-label>
                    {{ ("perigonId" | i18n) || "Perigon ID" }}
                  </mat-label>
                  <input
                    [disabled]="!hasEditPermission"
                    matInput
                    type="number"
                    [name]="customerInformation.customerName + 'perigonId'"
                    [(ngModel)]="customerInformation.perigonId" />
                </mat-form-field>
                <mat-form-field *ngIf="!customerInformation">
                  <mat-label>
                    {{ ("perigonId" | i18n) || "Perigon ID" }}
                  </mat-label>
                  <input
                    [disabled]="!hasEditPermission"
                    matInput
                    type="number"
                    name="perigonId"
                    [(ngModel)]="newPerigonId" />
                </mat-form-field>
              </div>
              <div
                class="col-sm-6"
                *ngIf="!(isEditingRequestedUser$ | async)">
                <mat-form-field
                  *ngIf="
                    !dispoCustomer?.hiddenFields?.profileITKnowledge &&
                    profileUser.role === roleEnum.POOL
                  ">
                  <mat-label>
                    {{ ("itKnowledge" | i18n) || "IT Kenntnisse" }}
                  </mat-label>
                  <input
                    matInput
                    [(ngModel)]="profileUser.itKnowledge"
                    name="itKnowledge"
                    [disabled]="
                      loggedInUser?.role === roleEnum.POOL || !hasEditPermission
                    " />
                </mat-form-field>
              </div>
              <div
                class="col-sm-6"
                *ngIf="!(isEditingRequestedUser$ | async)">
                <mat-form-field
                  *ngIf="
                    !dispoCustomer?.hiddenFields?.profileClothingSize &&
                    profileUser.role === roleEnum.POOL
                  ">
                  <mat-label>
                    {{ ("clothingSize" | i18n) || "Kleidergrösse" }}
                  </mat-label>
                  <input
                    matInput
                    [(ngModel)]="profileUser.clothingSize"
                    name="clothingSize"
                    [disabled]="
                      loggedInUser?.role === roleEnum.POOL || !hasEditPermission
                    " />
                </mat-form-field>
              </div>
              <div
                class="col-sm-6"
                *ngIf="!(isEditingRequestedUser$ | async)">
                <mat-form-field
                  *ngIf="
                    !dispoCustomer?.hiddenFields?.profileHeight &&
                    profileUser.role === roleEnum.POOL
                  ">
                  <mat-label>
                    {{ ("height" | i18n) || "Körpergrösse" }}
                  </mat-label>
                  <input
                    matInput
                    [(ngModel)]="profileUser.height"
                    type="number"
                    name="height"
                    [disabled]="
                      loggedInUser?.role === roleEnum.POOL || !hasEditPermission
                    " />
                </mat-form-field>
              </div>
              <div
                class="col-sm-6"
                *ngIf="!dispoCustomer?.hiddenFields?.profileHourlyWage">
                <mat-form-field
                  *ngIf="
                    customerInformation && loggedInUser?.role === roleEnum.DISPO
                  ">
                  <mat-label>
                    {{ ("hourlyWage" | i18n) || "Stundenlohn" }}
                  </mat-label>
                  <input
                    matInput
                    [name]="customerInformation.customerName + 'hourlyWage'"
                    [(ngModel)]="customerInformation.hourlyWage"
                    type="number"
                    [disabled]="!hasEditPermission" />
                </mat-form-field>
                <mat-form-field
                  *ngIf="
                    !customerInformation &&
                    loggedInUser?.role === roleEnum.DISPO
                  ">
                  <mat-label>
                    {{ ("hourlyWage" | i18n) || "Stundenlohn" }}
                  </mat-label>
                  <input
                    matInput
                    name="hourlyWage"
                    [(ngModel)]="newHourlyWage"
                    type="number"
                    [disabled]="!hasEditPermission" />
                </mat-form-field>
                <ng-container *ngIf="loggedInUser?.role === roleEnum.POOL">
                  <mat-form-field
                    *ngFor="let hourlyWage of poolerHourlyWages; let i = index">
                    <mat-label>
                      {{ ("hourlyWage" | i18n) || "Stundenlohn" }}
                      {{
                        loggedInUser?.role === roleEnum.POOL
                          ? "bei " + hourlyWage.customer
                          : ""
                      }}
                    </mat-label>
                    <input
                      matInput
                      [name]="i + 'readOnlyHourlyWage'"
                      [(ngModel)]="hourlyWage.wage"
                      type="number"
                      [disabled]="true" />
                  </mat-form-field>
                </ng-container>
              </div>
              <div
                class="col-sm-6"
                *ngIf="
                  profileUser.role === roleEnum.POOL &&
                  !dispoCustomer?.hiddenFields?.profileDateOfBirth &&
                  !(isEditingRequestedUser$ | async)
                ">
                <mat-form-field>
                  <mat-label>{{
                    ("dateOfBirth" | i18n) || "Geburtstag" | titlecase
                  }}</mat-label>
                  <input
                    matInput
                    [value]="
                      profileUser.dateOfBirth
                        ? (profileUser.dateOfBirth | date)
                        : ''
                    "
                    readonly
                    (click)="dateOfBirthDatePicker.open()"
                    [disabled]="!isDispoEditingPooler || !hasEditPermission" />
                  <input
                    matInput
                    name="user-date-of-birth-datepicker"
                    (dateChange)="selectDateOfBirth($event)"
                    (click)="dateOfBirthDatePicker.open()"
                    (keydown)="(false)"
                    [matDatepicker]="dateOfBirthDatePicker"
                    [(ngModel)]="datepickerDateOfBirth"
                    hidden
                    [disabled]="!isDispoEditingPooler || !hasEditPermission" />
                  <mat-datepicker-toggle
                    matSuffix
                    [for]="dateOfBirthDatePicker"></mat-datepicker-toggle>
                  <button
                    *ngIf="profileUser.dateOfBirth"
                    matSuffix
                    mat-icon-button
                    aria-label="Clear"
                    (click)="clearDateOfBirth()">
                    <mat-icon svgIcon="close"></mat-icon>
                  </button>
                  <mat-datepicker #dateOfBirthDatePicker></mat-datepicker>
                </mat-form-field>
              </div>
              <div
                class="col-sm-6"
                *ngIf="
                  profileUser.role === roleEnum.POOL &&
                  !dispoCustomer?.hiddenFields?.profilePlaceOfResidence &&
                  profileUser.placeOfResidence &&
                  !(isEditingRequestedUser$ | async)
                ">
                <div class="row">
                  <div class="col-sm-4">
                    <mat-form-field>
                      <mat-label>
                        {{ ("zip" | i18n) || "Körpergrösse" }}
                      </mat-label>
                      <input
                        matInput
                        [(ngModel)]="profileUser.placeOfResidence.zip"
                        type="number"
                        name="placeOfResidenceZip"
                        [disabled]="
                          loggedInUser?.role === roleEnum.POOL ||
                          !hasEditPermission
                        " />
                    </mat-form-field>
                  </div>
                  <div class="col-sm-8">
                    <mat-form-field>
                      <mat-label>
                        {{ ("location" | i18n) || "Körpergrösse" }}
                      </mat-label>
                      <input
                        matInput
                        [(ngModel)]="profileUser.placeOfResidence.location"
                        type="text"
                        name="placeOfResidenceLocation"
                        [disabled]="
                          loggedInUser?.role === roleEnum.POOL ||
                          !hasEditPermission
                        " />
                    </mat-form-field>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div
                *ngIf="!(isEditingRequestedUser$ | async)"
                class="col-sm-6">
                <mat-form-field
                  *ngIf="
                    profileUser.role === roleEnum.POOL &&
                    !dispoCustomer?.hiddenFields?.profileLanguages
                  ">
                  <mat-chip-list
                    #languageList
                    [disabled]="loggedInUser?.role === roleEnum.POOL">
                    <mat-chip
                      *ngFor="let language of profileUser.languages"
                      [disabled]="!isDispoEditingPooler || !hasEditPermission"
                      data-cy="language-mat-chip"
                      [selectable]="selectable">
                      {{
                        ("languageEnum." + $any(language) | i18n) ||
                          languageEnum[$any(language)]
                      }}

                      <mat-icon
                        *ngIf="isDispoEditingPooler && hasEditPermission"
                        matChipRemove
                        (click)="removeLanguage(language)"
                        svgIcon="close-circle"
                        [attr.data-cy]="
                          'remove-language-' + language
                        "></mat-icon>
                    </mat-chip>
                    <input
                      ngModel
                      [placeholder]="('languages' | i18n) || 'Sprachen'"
                      #languageInput="ngModel"
                      name="languageInput"
                      [matAutocomplete]="autoLanguages"
                      [matChipInputFor]="languageList"
                      [disabled]="!isDispoEditingPooler || !hasEditPermission"
                      data-cy="profile-languages-input" />
                  </mat-chip-list>
                  <mat-autocomplete
                    #autoLanguages="matAutocomplete"
                    (optionSelected)="selectedLanguage($event)">
                    <mat-option
                      *ngFor="let language of languageEnum | enumToArray"
                      [value]="languageEnum[language]">
                      {{
                        ("languageEnum." + languageEnum[language] | i18n) ||
                          language
                      }}
                    </mat-option>
                  </mat-autocomplete>
                </mat-form-field>
              </div>
              <div
                class="col-sm-6"
                *ngIf="dispoCustomer?.enableMonthlyHours">
                <mat-form-field
                  *ngIf="
                    customerInformation && loggedInUser?.role === roleEnum.DISPO
                  ">
                  <mat-label>
                    {{
                      ("monthlyHours" | i18n) || "Monatliches Pensum in Stunden"
                    }}
                  </mat-label>
                  <input
                    matInput
                    [name]="customerInformation.customerName + 'monthlyHours'"
                    [(ngModel)]="customerInformation.monthlyHours"
                    type="number"
                    [disabled]="!hasEditPermission" />
                </mat-form-field>
                <mat-form-field
                  *ngIf="
                    !customerInformation &&
                    loggedInUser?.role === roleEnum.DISPO
                  ">
                  <mat-label>
                    {{ ("monthlyHours" | i18n) || "Monatliches Pensum" }}
                  </mat-label>
                  <input
                    matInput
                    name="monthlyHours"
                    [(ngModel)]="newHourlyWage"
                    type="number"
                    [disabled]="!hasEditPermission" />
                </mat-form-field>
                <ng-container *ngIf="loggedInUser?.role === roleEnum.POOL">
                  <mat-form-field
                    *ngFor="
                      let monthlyHours of poolerMonthlyHours;
                      let i = index
                    ">
                    <mat-label>
                      {{ ("monthlyHours" | i18n) || "Monatliches Pensum" }}
                      {{
                        loggedInUser?.role === roleEnum.POOL
                          ? "bei " + monthlyHours.customer
                          : ""
                      }}
                    </mat-label>
                    <input
                      matInput
                      [name]="i + 'readOnlyMonthlyHours'"
                      [(ngModel)]="monthlyHours.hours"
                      type="number"
                      [disabled]="true" />
                  </mat-form-field>
                </ng-container>
              </div>
            </div>
            <div
              class="row"
              *ngIf="
                isDispoEditingPooler &&
                !dispoCustomer?.hiddenFields?.profileNotes
              ">
              <div class="col">
                <mat-form-field *ngIf="customerInformation">
                  <mat-label>{{
                    ("internalNote" | i18n) || "Interne Notizen"
                  }}</mat-label>
                  <textarea
                    [disabled]="!hasEditPermission"
                    matInput
                    [name]="customerInformation.customerName + 'internalNote'"
                    cdkTextareaAutosize
                    #autosize="cdkTextareaAutosize"
                    cdkAutosizeMinRows="1"
                    cdkAutosizeMaxRows="50"
                    [(ngModel)]="customerInformation.internalNote"></textarea>
                </mat-form-field>
                <mat-form-field *ngIf="!customerInformation">
                  <mat-label>{{
                    ("internalNote" | i18n) || "Interne Notizen"
                  }}</mat-label>
                  <textarea
                    [disabled]="!hasEditPermission"
                    matInput
                    cdkTextareaAutosize
                    #autosize="cdkTextareaAutosize"
                    cdkAutosizeMinRows="1"
                    cdkAutosizeMaxRows="50"
                    name="newNote"
                    [(ngModel)]="newNote"></textarea>
                </mat-form-field>
              </div>
            </div>
            <div
              *ngIf="dispoCustomer?.entryExitDates"
              class="row">
              <div
                class="col-md-6"
                data-cy="user-join-datepicker">
                <mat-form-field>
                  <mat-label>{{
                    ("joinDate" | i18n) || "Eintrittsdatum" | titlecase
                  }}</mat-label>
                  <input
                    matInput
                    [value]="joinDate ? (joinDate | date) : ''"
                    readonly
                    (click)="joinDatePicker.open()"
                    [disabled]="!isDispoEditingPooler || !hasEditPermission" />
                  <input
                    matInput
                    name="user-join-datepicker"
                    (dateChange)="selectJoinDate($event)"
                    (click)="joinDatePicker.open()"
                    (keydown)="(false)"
                    [matDatepicker]="joinDatePicker"
                    [(ngModel)]="datepickerJoin"
                    hidden
                    [disabled]="!isDispoEditingPooler || !hasEditPermission" />
                  <mat-datepicker-toggle
                    matSuffix
                    [for]="joinDatePicker"></mat-datepicker-toggle>
                  <button
                    *ngIf="joinDate"
                    matSuffix
                    mat-icon-button
                    aria-label="Clear"
                    (click)="clearJoinDate()">
                    <mat-icon svgIcon="close"></mat-icon>
                  </button>
                  <mat-datepicker #joinDatePicker></mat-datepicker>
                </mat-form-field>
              </div>
              <div
                class="col-md-6"
                data-cy="user-leave-datepicker">
                <mat-form-field>
                  <mat-label>{{
                    ("leaveDate" | i18n) || "Austrittsdatum" | titlecase
                  }}</mat-label>
                  <input
                    matInput
                    [value]="leaveDate ? (leaveDate | date) : ''"
                    readonly
                    (click)="leaveDatePicker.open()"
                    [disabled]="!isDispoEditingPooler || !hasEditPermission" />
                  <input
                    matInput
                    name="user-leave-datepicker"
                    (dateChange)="selectLeaveDate($event)"
                    (click)="leaveDatePicker.open()"
                    (keydown)="(false)"
                    [matDatepicker]="leaveDatePicker"
                    [(ngModel)]="datepickerLeave"
                    hidden
                    [disabled]="!isDispoEditingPooler || !hasEditPermission" />
                  <mat-datepicker-toggle
                    matSuffix
                    [for]="leaveDatePicker"></mat-datepicker-toggle>
                  <button
                    *ngIf="leaveDate"
                    matSuffix
                    mat-icon-button
                    aria-label="Clear"
                    (click)="clearLeaveDate()">
                    <mat-icon svgIcon="close"></mat-icon>
                  </button>
                  <mat-datepicker #leaveDatePicker></mat-datepicker>
                </mat-form-field>
              </div>
            </div>
            <div
              *ngIf="dispoCustomer?.enableTags"
              class="row">
              <div
                class="col-md-12"
                data-cy="user-tags">
                <app-tag-select
                  [selectedTags]="tags"
                  (tagAdded)="selectTag($event)"
                  (tagRemoved)="removeTag($event)"
                  (addNewlyCreatedTag)="
                    addNewlyCreatedTag($event)
                  "></app-tag-select>
              </div>
            </div>
          </div>
        </app-accordion-content>
      </app-accordion>
      <app-accordion
        *ngIf="
          (isDispoEditingPooler || loggedInUser?.role === roleEnum.POOL) &&
          editedUserRole === roleEnum.POOL &&
          customCriteriaDefinitionsForDisplay.length &&
          customerInformation?.customCriteria
        "
        class="custom-criteria-accordion"
        [collapsed]="customCriteriaCollapsed">
        <app-accordion-header
          [collapseOnHeaderClick]="true"
          (click)="customCriteriaCollapsed = !customCriteriaCollapsed"
          class="custom-criteria-accordion-header"
          data-cy="profile-custom-criteria-panel-header">
          <div class="accordion-title">
            {{ ("customCriteria" | i18n) || "Benutzerdefinierte Kriterien" }}
          </div>
        </app-accordion-header>
        <app-accordion-content class="custom-criteria-accordion-content">
          <div class="custom-criteria-accordion-content-inner">
            <div
              class="row"
              *ngFor="
                let customCriteria of customCriteriaDefinitionsForDisplay;
                trackBy: trackByCustomCriteriaId
              ">
              <div class="col-12">
                <ng-container
                  *ngIf="customCriteria.type === customCriteriaTypeEnum.TOGGLE">
                  <mat-slide-toggle
                    [(ngModel)]="
                      profileToggleCriterion(customCriteria.id).value
                    "
                    (ngModelChange)="touchCustomCriteriaInCustomerInformation()"
                    [name]="'profile-crit-toggle-' + customCriteria.id"
                    [attr.data-cy]="'profile-crit-toggle-' + customCriteria.id"
                    [disabled]="
                      isCustomCriteriaControlDisabled(customCriteria)
                    ">
                    {{ customCriteria.displayName }}
                  </mat-slide-toggle>
                </ng-container>
                <mat-form-field
                  *ngIf="customCriteria.type === customCriteriaTypeEnum.SELECT"
                  class="w-100">
                  <mat-label>{{ customCriteria.displayName }}</mat-label>
                  <mat-select
                    [multiple]="!!customCriteria.multiple"
                    [(ngModel)]="
                      profileSelectCriterion(customCriteria.id).values
                    "
                    (ngModelChange)="touchCustomCriteriaInCustomerInformation()"
                    [name]="'profile-crit-select-' + customCriteria.id"
                    [attr.data-cy]="'profile-crit-select-' + customCriteria.id"
                    [disabled]="
                      isCustomCriteriaControlDisabled(customCriteria)
                    ">
                    <mat-option
                      *ngFor="
                        let option of getSelectOptionsForCustomCriteria(
                          customCriteria
                        )
                      "
                      [value]="option">
                      {{ option.displayName }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
          </div>
        </app-accordion-content>
      </app-accordion>
      <div
        class="row"
        *ngIf="profileUser && !(isEditingRequestedUser$ | async)">
        <div class="col">
          <mat-form-field
            class="mat-form-field--no-underline mat-form-field--type-checkbox"
            [hintLabel]="
              (loggedInUser?.role === roleEnum.POOL || isDispoEditingPooler) &&
              !profileUser.notifyEmail &&
              !profileUser.notifySms
                ? ('noNotificationSelected' | i18n) ||
                  'Wenn Sie keine der zwei Optionen oder Push aktivieren, werden Sie bei neuen Dienstanfragen nicht automatisch informiert.'
                : ''
            ">
            <input
              [disabled]="!hasEditPermission && !partialOwnEditPermissions"
              matInput
              style="display: none" />
            <mat-checkbox
              [disabled]="!hasEditPermission && !partialOwnEditPermissions"
              [(ngModel)]="profileUser.notifyEmail"
              name="notifyEmail">
              {{
                ("getNotificationEmail" | i18n) || "Get notifications via email"
              }}
            </mat-checkbox>
            <br />
            <mat-checkbox
              [(ngModel)]="profileUser.notifySms"
              [disabled]="
                !!(
                  !profileUser.phone ||
                  (!hasEditPermission && !partialOwnEditPermissions) ||
                  (isDemo$ | async)
                )
              "
              name="notifySms"
              data-cy="profile-sms-checkbox">
              {{ ("getNotificationSms" | i18n) || "Get notifications via sms" }}
            </mat-checkbox>
            <br />
            <div
              class="profile-sms-demo-hint"
              *ngIf="loggedInUser?.isDemo"
              data-cy="profile-sms-demo-hint">
              {{ "smsDisabledForDemo" | i18n }}
            </div>
            <mat-checkbox
              [(ngModel)]="profileUser.twoFactorAuthEnabled"
              [disabled]="
                !!(
                  (!hasEditPermission && !partialOwnEditPermissions) ||
                  profileUser?.twoFactorAuthRequired
                )
              "
              name="twoFactorAuthEnabled">
              {{
                ("twoFactorAuthEnabled" | i18n) ||
                  "Zwei-Faktor-Authentifizierung aktiviert"
              }}
            </mat-checkbox>
            <br />
          </mat-form-field>
          <mat-checkbox
            [disabled]="!hasEditPermission && !partialOwnEditPermissions"
            *ngIf="
              (isSelfDispo || editedUserRole === roleEnum.DISPO) &&
              profileUser &&
              profileUser.role === roleEnum.DISPO &&
              profileUser.notifyEmail
            "
            [(ngModel)]="profileUser.getOwnJobConfirmations"
            name="getOwnJobConfirmations">
            {{
              ("getOwnJobConfirmations" | i18n) ||
                "Buchungsbestätigungen für eigene Dienste erhalten"
            }}
          </mat-checkbox>
          <br />
          <mat-checkbox
            *ngIf="
              isSelfDispo &&
              loggedInUser?._id === profileUser?._id &&
              profileUser.role === roleEnum.DISPO
            "
            [disabled]="!hasEditPermission && !partialOwnEditPermissions"
            [(ngModel)]="profileUser.disableUnsavedChangesWarning"
            name="disableUnsavedChangesWarning"
            data-cy="profile-disable-unsaved-changes-warning-checkbox">
            {{ "disableUnsavedChangesWarning" | i18n }}
          </mat-checkbox>
          <ng-container
            *ngIf="
              isSelfDispo &&
              profileUser?.role === roleEnum.DISPO &&
              profileUser.notifyEmail
            ">
            <mat-form-field class="mt-4">
              <mat-label>
                {{
                  ("disabledEmails" | i18n) || "Abgewählte Emails"
                }}</mat-label
              >
              <mat-select
                *ngIf="profileUser && profileUser.role === roleEnum.DISPO"
                multiple
                name="disabledDispoEmails"
                [(ngModel)]="profileUser.disabledDispoEmails">
                <mat-option
                  *ngFor="
                    let notificationType of creatorNotificationEnumArray$
                      | async
                  "
                  [value]="notificationType"
                  >{{
                    ("creatorNotifications." + notificationType | i18n) ||
                      notificationType
                  }}</mat-option
                >
              </mat-select>
            </mat-form-field>
          </ng-container>
        </div>
      </div>
    </div>
    <div
      class="card-box departments-card"
      *ngIf="showDepartments">
      <h1 class="card-title">
        {{ ("departments" | i18n) || "Departments" }}
      </h1>
      <app-department-multiselect
        *ngIf="multiselectModeForRole as mode"
        data-cy="profile-department-multiselect"
        [disabled]="!hasEditPermission"
        [profileUser]="profileUser"
        [mode]="mode"
        (unsavedChanges)="
          selectedDepartmentIds($event)
        "></app-department-multiselect>
    </div>
    <div
      class="card-box"
      *ngIf="
        (loggedInUser?.role === roleEnum.POOL &&
          profileUser &&
          !profileUser.isInSetup) ||
        (isDispoEditingPooler &&
          editedUserRole === roleEnum.POOL &&
          !(isEditingRequestedUser$ | async))
      ">
      <h1 class="card-title">
        {{ ("jobSettings" | i18n) || "Diensteinstellungen" | titlecase }}
      </h1>
      <div
        class="row"
        *ngIf="profileUser && profileUser.role === roleEnum.POOL">
        <div class="col mb-4">
          {{
            ("defaultJobTypesHint" | i18n) ||
              "Die hier ausgewählten Jobarten werden Standardmässig berücksichtigt."
          }}
          <mat-selection-list
            *ngIf="profileUser"
            [(ngModel)]="profileUser.jobTypes"
            name="jobTypes"
            required
            [disabled]="!hasEditPermission"
            data-cy="profile-jobType-checkboxes">
            <mat-list-option
              *ngFor="
                let type of jobTypeEnum | enumToArray;
                trackBy: trackShift
              "
              checkboxPosition="before"
              color="primary"
              [value]="jobTypeEnum[type]">
              {{ ("jobTypeEnum." + jobTypeEnum[type] | i18n) || type }}
            </mat-list-option>
          </mat-selection-list>
          <mat-hint
            class="important-hint"
            *ngIf="
              profileUser &&
              profileUser.role === roleEnum.POOL &&
              (!profileUser ||
                !profileUser.jobTypes ||
                profileUser.jobTypes?.length === 0)
            ">
            {{
              ("noJobTypeSelected" | i18n) ||
                "Wenn keine Dienstart aktiviert ist erhalten sie keine Dienstanfragen."
            }}
          </mat-hint>
        </div>
      </div>
      <div
        class="row"
        *ngIf="profileUser && profileUser.role === roleEnum.POOL">
        <div class="col">
          {{
            ("defaultShiftsHint" | i18n) ||
              "Die hier ausgewählten Schichten werden Standardmässig berücksichtigt."
          }}
          <mat-selection-list
            *ngIf="profileUser"
            [(ngModel)]="profileUser.shifts"
            name="shifts"
            required
            [disabled]="!hasEditPermission"
            data-cy="profile-shift-checkboxes">
            <mat-list-option
              *ngFor="let shift of shiftEnum | enumToArray; trackBy: trackShift"
              checkboxPosition="before"
              color="primary"
              [value]="shiftEnum[$any(shift)]">
              {{ "shifts." + shiftEnum[shift] | i18n }}
            </mat-list-option>
          </mat-selection-list>
          <mat-hint
            class="important-hint"
            *ngIf="
              profileUser &&
              profileUser.role === roleEnum.POOL &&
              (!profileUser ||
                !profileUser.shifts ||
                profileUser.shifts?.length === 0)
            ">
            {{
              ("noShiftSelected" | i18n) ||
                "Wenn keine Schicht aktiviert ist erhalten sie keine Dienstanfragen."
            }}
          </mat-hint>
        </div>
      </div>
    </div>
    <div
      *ngIf="!(isEditingRequestedUser$ | async)"
      class="card-box"
      [class.hidden]="
        (profileUser &&
          profileUser.isInSetup &&
          loggedInUser?.role === roleEnum.POOL) ||
        (loggedInUser?.role === roleEnum.DISPO && !isDispoEditingPooler) ||
        editedUserRole === roleEnum.DISPO ||
        editedUserRole === roleEnum.REQUESTER ||
        loggedInUser?.role === roleEnum.REQUESTER
      ">
      <h1 class="card-title">
        {{ ("certificates" | i18n) || "Qualifikation" | titlecase }}
      </h1>
      <div
        class="card-subtitle qualification-hint"
        *ngIf="loggedInUser?.role === roleEnum.POOL">
        {{
          ("qualificationsProfileEditText" | i18n) ||
            "Folgende Angaben können nicht von Ihnen selbst bearbeitet werden. Falls diese nicht korrekt sind, kontaktieren Sie bitte Ihren Arbeitgeber."
        }}
      </div>
      <div class="row">
        <div class="col-md-6">
          <app-certificate-select
            *ngIf="profileUser && profileUser.role === roleEnum.POOL"
            [selectedMappedCertificates]="profileUser.certificates || []"
            [disabled]="!isDispoEditingPooler || !hasEditPermission"
            [doNotUpdateRecentlyUsed]="true"
            [noCertificateGroups]="true"
            (selectionChanged)="
              certificateSelectionChanged($event)
            "></app-certificate-select>
        </div>
        <div class="col-md-6">
          <app-speciality-select
            *ngIf="profileUser && profileUser.role === roleEnum.POOL"
            [selectedMappedSpecialities]="profileUser.specialities || []"
            [disabled]="!isDispoEditingPooler || !hasEditPermission"
            [doNotUpdateRecentlyUsed]="true"
            (selectionChanged)="
              specialitySelectionChanged($event)
            "></app-speciality-select>
        </div>
      </div>
      <div
        class="row"
        *ngIf="
          profileUser &&
          ((loggedInUser?.role === roleEnum.POOL &&
            profileUser &&
            profileUser.role === roleEnum.POOL &&
            profileUser.degrees &&
            profileUser.degrees.length > 0) ||
            isDispoEditingPooler) &&
          !dispoCustomer?.hiddenFields?.profileDegrees
        ">
        <div
          class="col"
          *ngIf="profileUser && profileUser.role === roleEnum.POOL">
          <h3>{{ ("graduations" | i18n) || "Abschlüsse" }}</h3>
          <mat-form-field
            *ngFor="
              let degree of profileUser.degrees;
              let i = index;
              trackBy: trackByIndex
            ">
            <input
              [disabled]="!hasEditPermission"
              matInput
              type="text"
              required
              [(ngModel)]="profileUser.degrees![i]"
              [name]="'degree' + i"
              [readonly]="!isDispoEditingPooler"
              data-cy="profile-degree-input" />
            <button
              [disabled]="!hasEditPermission"
              mat-button
              matSuffix
              mat-icon-button
              aria-label="Clear"
              type="button"
              (click)="removeDegree($event, i)"
              *ngIf="isDispoEditingPooler"
              data-cy="profile-remove-degree-button">
              <mat-icon svgIcon="minus"></mat-icon>
            </button>
          </mat-form-field>
          <button
            *ngIf="isDispoEditingPooler"
            [disabled]="!hasEditPermission"
            class="profile-edit__icon-button"
            mat-button
            type="button"
            (click)="addDegree($event)"
            data-cy="add-degree-button">
            <span>{{
              ("addGraduations" | i18n) || "Abschluss hinzufügen"
            }}</span>
            <mat-icon
              class="profile-edit__inline-icon"
              svgIcon="plus"></mat-icon>
          </button>
        </div>
      </div>
    </div>
    <div
      class="card-box"
      *ngIf="dispoCustomer?.enablePoolerDocuments && isDispoEditingPooler">
      <app-cv-upload
        [loggedInUserWithCustomer]="userWithCustomer"
        [customerInformation]="customerInformation"
        [isNewUser]="isNewUser"
        (temporaryFilesChange)="onTemporaryFilesChange($event)"></app-cv-upload>
    </div>
    <div
      class="card-box permissions"
      *ngIf="
        profileUser?.role === roleEnum.DISPO &&
        (permissionsService.canReadPermissions$ | async)
      ">
      <h1 class="card-title">
        {{ ("permissions" | i18n) || "Berechtigungen" }}
      </h1>
      <app-feature-permission
        *ngIf="profileUser"
        (permissionChanged)="updatePermissions($event)"
        [hasJobs]="
          dispoCustomer?.hasJobAssignments || dispoCustomer?.enableJobs || false
        "
        [hasEmployments]="
          dispoCustomer?.hasEmployments ||
          dispoCustomer?.enableEmployments ||
          false
        "
        [hasRequestProcess]="dispoCustomer?.enableJobRequestProcess || false"
        [hasTimeTracking]="dispoCustomer?.timeTrackingEnabled || false"
        [customerType]="dispoCustomer?.customerType"
        [profileUser]="profileUser"></app-feature-permission>
    </div>
    <div
      class="card-box permissions"
      *ngIf="
        profileUser?.role === roleEnum.DISPO &&
        (permissionsService?.userIsCustomerAdmin$ | async)
      ">
      <h1 class="card-title">
        {{ ("adminPermissions" | i18n) || "Admin Berechtigungen" }}
      </h1>
      <app-feature-permission
        *ngIf="profileUser"
        (permissionChanged)="updateFeaturePermissions($event.dispoAccess!)"
        [isAdminPermissions]="true"
        [customerType]="dispoCustomer?.customerType"
        [profileUser]="profileUser"></app-feature-permission>
    </div>
    <div class="a-fixed-action-bar a-fixed-action-bar--fixed-bottom">
      <button
        class="mat-fab mat-fab--extended mat-fab-neutral mat-elevation-z8 d-none d-lg-inline-flex"
        *ngIf="isDispoEditingPooler"
        (click)="historyBack()"
        type="button">
        <ng-container *ngIf="profileForm.form.dirty">
          <mat-icon
            class="mat-fab__icon"
            svgIcon="close-circle-outline"></mat-icon>
          <span class="mat-fab__label">
            {{ ("cancel" | i18n) || "abbrechen" | uppercase }}</span
          >
        </ng-container>
        <ng-container *ngIf="!profileForm.form.dirty">
          <mat-icon
            class="mat-fab__icon"
            svgIcon="arrow-left"></mat-icon>
          <span class="mat-fab__label">
            {{ ("back" | i18n) || "zurück" | uppercase }}</span
          >
        </ng-container>
      </button>
      <button
        *ngIf="profileForm.form.dirty"
        class="mat-fab mat-fab--extended mat-elevation-z8"
        type="button"
        color="primary"
        [class.disabled]="!profileForm.form.valid"
        (click)="saveProfile()"
        data-cy="profile-save-button">
        <mat-icon
          class="mat-fab__icon"
          svgIcon="save"></mat-icon>
        <span
          class="mat-fab__label"
          *ngIf="!isNewUser"
          >{{ ("save" | i18n) || "save" | titlecase }}</span
        >
        <span
          class="mat-fab__label"
          *ngIf="isNewUser"
          >{{ ("create" | i18n) || "create" | titlecase }}</span
        >
      </button>
    </div>
  </ng-container>
  <ng-template #loadingProfile>
    <div
      class="loading-profile"
      data-cy="loading-profile-spinner">
      <mat-spinner
        diameter="34"
        class="loading-profile-spinner"></mat-spinner>
      <div>{{ "loadingProfile" | i18n }}</div>
    </div>
  </ng-template>
</form>

<ng-template #notConnectedLabel>
  <span>{{ ("notConnected" | i18n) || "Not connected" }}</span>
</ng-template>

<ng-template #deleteConfirm>
  <h2 mat-dialog-title>
    {{ ("deleteConfirmTitle" | i18n) || "Remove this document?" }}
  </h2>
  <mat-dialog-content>
    {{
      ("deleteConfirmContent" | i18n) ||
        "Dies wird dieses Dokument löschen und kann nicht rückgängig gemacht werden"
    }}
    <br /><br />
  </mat-dialog-content>
  <mat-dialog-actions>
    <button
      mat-flat-button
      mat-dialog-close>
      {{ ("cancel" | i18n) || "cancel" | titlecase }}
    </button>
    <button
      mat-flat-button
      color="warn"
      [mat-dialog-close]="true">
      {{ ("remove" | i18n) || "remove" | titlecase }}
    </button>
  </mat-dialog-actions>
</ng-template>
